import { useFamily } from '@/context/FamilyContext'
import { BlockedAccess } from './BlockedAccess'

interface RequireNotBlockedProps {
  children: React.ReactNode
}

/**
 * Wrapper that shows BlockedAccess screen if user has been disabled by admin.
 * Uses computed effective entitlements from FamilyContext.
 */
export function RequireNotBlocked({ children }: RequireNotBlockedProps) {
  const { isBlocked, isLoading } = useFamily()

  // While loading, don't show blocked screen (might flash incorrectly)
  if (isLoading) {
    return <>{children}</>
  }

  // If user is blocked, show the blocked access screen
  if (isBlocked) {
    return <BlockedAccess />
  }

  return <>{children}</>
}
